import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import CompactDropdown from 'views/scenes/client/detail/client_scenes/client_feed/header/client_details/dropdowns/CompactDropdown';

const DomainGuideStatusDropdown = (props) => {
  const {
    label,
    selectedStatus,
    setSelectedStatus,
  } = props;

  const statuses = ['ACTIVE', 'INACTIVE', 'DELETED'];
  const selectedStatusLabel = selectedStatus ?
    translate(`domainGuide.Status.${selectedStatus}.Title`) :
    translate('domainGuide.Detail.EmptyValue');

  const handleOptionSelect = (selectedOption) => {
    if (!selectedOption || selectedOption === selectedStatus) {
      return;
    }

    setSelectedStatus(selectedOption);
  };

  return (
    <CompactDropdown
      getOptionKey={(option) => option}
      getOptionLabel={(option) => translate(`domainGuide.Status.${option}.Title`)}
      isOptionSelected={(option) => selectedStatus === option}
      label={label}
      menuLabel={label}
      onOptionSelect={handleOptionSelect}
      options={statuses}
      value={selectedStatusLabel}
    />
  );
};

DomainGuideStatusDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  selectedStatus: PropTypes.string,
  setSelectedStatus: PropTypes.func.isRequired,
};

export default React.memo(DomainGuideStatusDropdown);
